import React from "react";
import { UserAvatar } from "../Profile/UserAvatar";
import { XP_ICON_SRC, formatXp } from "../../utils/xp";

/** History rows: no left padding so avatar aligns with box edge; right inset matches stat cells. */
const XP_HISTORY_ROW_PX = "pl-0 pr-2";

export type XpHistoryListItem = {
  amount: number;
  detail: string;
  relative: string;
  iconSrc?: string | null;
  displayName?: string | null;
  avatarFrameUrl?: string | null;
  avatarFrameSmallUrl?: string | null;
};

const YOU_LABEL_CLASS =
  "font-anton text-[9px] font-normal not-italic uppercase leading-[16px] tracking-[0%] text-white [leading-trim:none]";

const HISTORY_BODY_CLASS =
  "font-chakra text-[10px] font-normal not-italic leading-[16px] tracking-[0%] text-white [leading-trim:none]";

const HISTORY_TIME_CLASS =
  "font-chakra text-[10px] font-normal not-italic leading-[16px] tracking-[0%] text-white/45 [leading-trim:none]";

type XpHistoryListRowProps = {
  item: XpHistoryListItem;
};

export function XpHistoryListRow({ item }: XpHistoryListRowProps) {
  return (
    <li className={`flex h-[30px] w-full items-center gap-2 bg-[#1B062F4D] ${XP_HISTORY_ROW_PX}`}>
      <UserAvatar
        src={item.iconSrc}
        displayName={item.displayName}
        avatarFrameUrl={item.avatarFrameUrl}
        avatarFrameSmallUrl={item.avatarFrameSmallUrl}
        size="sm"
      />
      <div className="flex min-h-0 min-w-0 flex-1 items-center gap-1.5 overflow-hidden">
        <span className={`shrink-0 ${YOU_LABEL_CLASS}`}>YOU</span>
        <span className={`inline-flex min-w-0 items-center gap-1 truncate ${HISTORY_BODY_CLASS}`}>
          <span className="truncate">earned +{formatXp(item.amount)} XP</span>
          <img src={XP_ICON_SRC} alt="" className="h-[17px] w-[17px] shrink-0 object-contain" aria-hidden />
          <span className="truncate">{item.detail}</span>
        </span>
      </div>
      <span className={`flex shrink-0 items-center ${HISTORY_TIME_CLASS}`}>{item.relative}</span>
    </li>
  );
}
